
import accountTransformer from './../../transformers/account';
import store from './../../store';
import Vue from 'vue';

// When the request succeeds
const success = (account, resolve) => {
  account = accountTransformer.fetch(account);
  store.dispatch('getAccount', account);
  resolve(account);
};

// When the request fails
const failed = (error, reject) => {
  reject(error);
};

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/account')
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/account/find.js